var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 449,
    viewBox: "0 0 480 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.968 27.0234H429.614C439.634 27.0234 447.756 35.146 447.756 45.1658V215.839C447.756 225.859 439.634 233.982 429.614 233.982H115.968C105.948 233.982 97.8258 225.859 97.8258 215.839V45.1658C97.8258 35.146 105.948 27.0234 115.968 27.0234Z",
    fill: "#3F0099"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.105 87.6348H419.913C424.507 87.6348 428.231 91.3592 428.231 95.9535V205.328C428.231 209.923 424.507 213.647 419.913 213.647H127.105C122.511 213.647 118.786 209.923 118.786 205.328V95.9535C118.786 91.3592 122.511 87.6348 127.105 87.6348Z",
    fill: "#9E7CF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.949 100.395H405.965C410.56 100.395 414.284 104.119 414.284 108.713V190.974C414.284 195.568 410.56 199.293 405.965 199.293H361.949C357.355 199.293 353.63 195.568 353.63 190.974V108.713C353.63 104.119 357.355 100.395 361.949 100.395Z",
    fill: "#3F0099"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.514 100.395H332.53C337.124 100.395 340.849 104.119 340.849 108.713V190.974C340.849 195.568 337.124 199.293 332.53 199.293H288.514C283.919 199.293 280.195 195.568 280.195 190.974V108.713C280.195 104.119 283.919 100.395 288.514 100.395Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.092 100.395H259.109C263.703 100.395 267.427 104.119 267.427 108.713V190.974C267.427 195.568 263.703 199.293 259.109 199.293H215.092C210.498 199.293 206.774 195.568 206.774 190.974V108.713C206.774 104.119 210.498 100.395 215.092 100.395Z",
    fill: "#3F0099"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.664 100.395H185.68C190.275 100.395 193.999 104.119 193.999 108.713V190.974C193.999 195.568 190.275 199.293 185.68 199.293H141.664C137.07 199.293 133.345 195.568 133.345 190.974V108.713C133.345 104.119 137.07 100.395 141.664 100.395Z",
    fill: "#3F0099"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M414.948 130.106C379.02 130.106 349.895 100.98 349.895 65.0528C349.895 29.1251 379.02 0 414.948 0C450.875 0 480 29.1251 480 65.0528C480 100.98 450.875 130.106 414.948 130.106Z",
    fill: "#10C6AC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_18556",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 349,
    y: 0,
    width: 132,
    height: 131
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M414.948 130.106C379.02 130.106 349.895 100.98 349.895 65.0528C349.895 29.1251 379.02 0 414.948 0C450.875 0 480 29.1251 480 65.0528C480 100.98 450.875 130.106 414.948 130.106Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_18556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.195 113.054L369.651 169.267C369.122 177.429 371.255 185.003 379.359 186.103C387.86 187.253 395.69 181.324 396.881 172.823L415.52 116.552C416.653 108.432 411.923 100.634 404.199 97.8969C393.4 94.0601 381.939 101.618 381.195 113.046V113.054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.241 104.86L444.653 160.296L393.666 158.724L389.259 99.5592C389.259 99.5592 397.817 92.3237 421.781 94.1347C447.796 96.1027 460.241 104.86 460.241 104.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.614 130.625L480.464 172.351C487.211 176.974 494.819 179 499.904 172.591C505.23 165.868 501.293 155.664 500.26 154.358C500.26 154.358 479.992 120.934 460.147 104.404C453.846 99.1616 444.626 99.3766 438.325 104.619C429.518 111.946 430.163 124.151 439.614 130.625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.312 22.9047C401.312 22.9047 434.447 17.2403 445.775 34.5227C454.193 47.3563 446.478 62.406 429.163 68.9717C412.666 75.2314 418.024 29.0734 418.024 29.0734L401.312 22.9129V22.9047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.563 22.6314C416.563 22.6314 386.596 18.0339 385.537 37.4993C384.81 50.9365 406.003 55.6498 406.003 55.6498L416.571 22.6314H416.563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.244 56.9148C405.55 61.3305 402.217 65.159 397.802 65.4733C393.386 65.7792 389.557 62.4468 389.243 58.0311C388.937 53.6154 392.269 49.7868 396.685 49.4726C401.101 49.1667 404.929 52.4991 405.244 56.9148Z",
    fill: "#FFA283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.602 78.6377L408.71 96.0772C409.09 102.205 411.406 104.892 417.616 104.851C422.759 104.495 428.746 102.626 429.159 96.3252L426.091 68.9629L407.593 78.6294L407.602 78.6377Z",
    fill: "#FFBB9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.367 93.175L428.75 73.2217L407.449 76.8601L408.367 93.175Z",
    fill: "#FFA283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.9 81.458C402.597 81.4911 394.088 73.3792 393.782 64.9612L393.178 45.1072C392.79 34.5641 400.844 25.617 411.362 24.8811C422.137 24.1286 433.366 32.1247 434.118 42.8994L434.433 58.8752C434.672 71.2292 425.229 80.5981 412.9 81.458Z",
    fill: "#FFBB9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.601 59.9336L404.006 64.862L406.553 64.9529",
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.781 47.7858C414.781 47.7858 409.091 47.3228 409.034 49.6381C409.034 49.6381 409.034 51.2092 414.003 51.5152C418.973 51.8211 420.263 51.4656 420.718 49.9854C421.173 48.5135 417.452 47.7941 414.789 47.7858H414.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.276 47.8606C398.276 47.8606 402.584 47.5133 402.99 49.5971C402.99 49.5971 403.229 51.0028 399.459 51.2261C395.68 51.4411 394.514 50.978 394.439 49.779C394.357 48.3567 396.217 47.844 398.276 47.8606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.777 58.0475C400.81 59.0563 400.024 59.8915 399.016 59.9246C398.007 59.9577 397.172 59.1721 397.139 58.1633C397.105 57.1544 397.891 56.3192 398.9 56.2862C399.909 56.2531 400.744 57.0387 400.777 58.0475Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.069 57.5514C416.102 58.5602 415.317 59.3954 414.308 59.4284C413.299 59.4615 412.464 58.6759 412.431 57.6671C412.398 56.6583 413.183 55.8231 414.192 55.7901C415.201 55.757 416.036 56.5426 416.069 57.5514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.25 71.4268C414.25 71.4268 412.075 74.9329 404.757 73.4031",
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.447 27.2289C399.241 26.4599 399.067 25.6661 398.959 24.8392C398.959 24.8392 430.192 17.3722 438.643 37.8051L437.154 38.9214C441.239 41.5592 444.547 44.3046 444.547 44.3046L430.167 56.4601C430.167 56.4601 425.619 54.0704 423.924 46.5868C417.945 45.0901 407.08 41.8239 402.242 35.0598C399.406 39.4093 395.329 43.8415 390.492 43.8415C390.492 43.8415 389.061 32.455 399.456 27.2206L399.447 27.2289Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.053 59.1648C444.359 63.5805 441.027 67.4091 436.611 67.7233C432.195 68.0293 428.367 64.6968 428.053 60.2811C427.747 55.8655 431.079 52.0368 435.495 51.7226C439.91 51.4167 443.739 54.7491 444.053 59.1648Z",
    fill: "#FFBB9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.426 62.2902C433.426 62.2902 433.021 56.4936 438.627 57.0146",
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.316 155.409L408.959 116.122L403.865 110.408L412.514 105.116L419.129 111.219L412.977 116.668C412.977 116.668 414.441 134.877 413.54 156.327C405.833 176.214 398.945 193.976 398.945 193.976L397.324 155.409H397.316Z",
    fill: "#F84511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.161 94.9038C429.161 94.9038 416.055 105.207 413.194 104.744C410.332 104.281 408.612 94.0107 408.612 94.0107C408.612 94.0107 398.648 96.4336 397.4 97.8559C396.151 99.2782 399.194 113.228 400.542 113.906C403.362 115.328 411.862 105.844 413.409 107.051C414.955 108.258 419.337 116.362 420.785 116.205C422.232 116.04 433.717 104.711 433.072 100.543C432.427 96.3757 429.161 94.9038 429.161 94.9038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.29 57.8662C410.348 61.6203 413.449 64.622 417.203 64.5559C420.957 64.498 423.951 61.3971 423.893 57.6429C423.835 53.8888 420.734 50.8871 416.98 50.9532C413.226 51.0111 410.232 54.112 410.29 57.8662Z",
    stroke: "white",
    strokeWidth: 1.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.312 57.4773C392.378 61.3307 395.545 64.3985 399.399 64.3323C403.252 64.2662 406.32 61.0991 406.254 57.2457C406.188 53.3924 403.021 50.3245 399.167 50.3907C395.314 50.4569 392.246 53.6239 392.312 57.4773Z",
    stroke: "white",
    strokeWidth: 1.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.304 58.4526C410.304 58.4526 408.46 57.022 406.178 58.5187",
    stroke: "white",
    strokeWidth: 1.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.176 56.9821L428.815 54.9893",
    stroke: "white",
    strokeWidth: 1.34,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240.243 397.353L220.182 354.816L200.171 367.261L222.166 412.634L240.863 399.759L240.243 397.353Z",
    fill: "#F0B99B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.339 404.812C216.339 404.812 236.879 400.239 237.152 384.66L283.93 381.691L222.4 424.046L216.33 404.812H216.339Z",
    fill: "#3F0099"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M283.962 381.646L287.863 387.313L226.335 429.664L222.434 423.997L283.962 381.646Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.844 393.674C242.968 393.483 243.043 393.26 243.051 393.02C243.266 387.985 244.647 384.611 244.664 384.578C244.936 383.916 244.631 383.18 243.969 382.94C243.308 382.701 242.547 383.056 242.274 383.701C242.208 383.858 240.695 387.513 240.455 393.037C240.422 393.74 240.984 394.31 241.695 394.31C242.166 394.31 242.596 394.054 242.836 393.682L242.844 393.674Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M249.957 392.632C250.081 392.442 250.156 392.218 250.164 391.978C250.379 386.943 251.76 383.569 251.776 383.536C252.049 382.874 251.743 382.138 251.082 381.898C250.42 381.659 249.651 382.014 249.387 382.659C249.321 382.816 247.807 386.471 247.567 391.995C247.534 392.698 248.097 393.268 248.808 393.268C249.279 393.268 249.709 393.012 249.949 392.64L249.957 392.632Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M257.07 391.59C257.194 391.399 257.268 391.176 257.277 390.936C257.492 385.901 258.881 382.527 258.889 382.494C259.162 381.832 258.856 381.096 258.194 380.856C257.533 380.617 256.764 380.964 256.499 381.617C256.433 381.774 254.92 385.429 254.68 390.953C254.647 391.656 255.209 392.226 255.929 392.226C256.4 392.226 256.83 391.97 257.07 391.598V391.59Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.552 277.624L238.702 367.153L198.936 389.157L160.303 318.3L192.552 277.624Z",
    fill: "#1F2421"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.045 412.939L167.934 366.583L144.408 365.334L136.478 415.122L159.177 415.271L160.045 412.939Z",
    fill: "#F0B99B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.185 405.382C136.185 405.382 155.642 413.386 164.787 400.768L204.851 425.103L130.156 424.624L136.185 405.382Z",
    fill: "#3F0099"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.129 424.591L204.822 425.073L204.777 431.953L130.084 431.471L130.129 424.591Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M164.299 411.418C164.505 411.336 164.696 411.195 164.844 411.005C167.904 407.003 170.972 405.018 171.005 405.001C171.609 404.613 171.774 403.836 171.369 403.257C170.963 402.678 170.137 402.537 169.541 402.909C169.401 403 166.068 405.134 162.711 409.525C162.281 410.087 162.413 410.872 163 411.278C163.389 411.551 163.885 411.584 164.299 411.41V411.418Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M170.724 414.635C170.931 414.552 171.121 414.412 171.27 414.221C174.329 410.219 177.397 408.235 177.43 408.218C178.034 407.838 178.199 407.052 177.794 406.473C177.389 405.894 176.562 405.746 175.967 406.126C175.826 406.217 172.494 408.35 169.136 412.741C168.706 413.303 168.838 414.089 169.426 414.494C169.814 414.767 170.31 414.8 170.724 414.627V414.635Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.157 417.852C177.364 417.769 177.554 417.628 177.703 417.438C180.762 413.436 183.83 411.46 183.863 411.435C184.467 411.046 184.632 410.269 184.227 409.69C183.822 409.111 182.995 408.962 182.4 409.343C182.259 409.434 178.927 411.567 175.569 415.958C175.139 416.52 175.272 417.306 175.859 417.711C176.247 417.984 176.744 418.017 177.157 417.843V417.852Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6775 250.196L172.301 256.001C185.954 257.002 196.158 268.967 194.984 282.603C193.892 295.304 183.258 305.062 170.507 305.062H73.0891C73.0891 305.062 34.9854 296.429 46.1652 259.846L90.6775 250.196Z",
    fill: "#1F2421"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M194.988 282.603L175.597 390.564L131.729 388.629L147.755 281.619L194.988 282.603Z",
    fill: "#1F2421"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.737 140.399L113.845 159.252L97.0421 144.847L117.946 116.873L127.737 140.399Z",
    fill: "#FFBB9B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M119.608 151.438C119.848 151.107 120.187 137.116 120.187 137.116L126.158 142.549L119.608 151.438Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.546 98.3416C147.546 98.3416 157.039 103.229 153.542 116.021C153.542 116.021 150.904 125.257 147.001 138.529C144.933 145.541 136.822 149.163 130.504 145.484C126.634 143.226 122.549 140.018 119.456 135.519L115.388 128.226C106.706 108.736 126.89 88.4849 146.149 97.6553C146.612 97.8703 147.075 98.11 147.546 98.3498V98.3416Z",
    fill: "#FFBB9B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M148.25 128.789L151.426 134.594C151.864 135.388 151.161 136.339 150.276 136.149L145.563 135.173L148.242 128.789H148.25Z",
    fill: "#F0B99B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M126.947 116.683C126.947 116.683 122.358 85.8149 153.855 105.346C153.855 105.346 145.652 84.864 121.878 87.7086C116.338 88.3701 109.359 92.6039 106.779 97.5488C102.595 105.553 105.646 113.682 108.904 129.409C108.904 129.409 114.957 131.386 120.415 122.579C121.622 120.628 126.947 116.692 126.947 116.692V116.683Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M129.18 120.958C129.18 120.958 140.211 117.65 136.986 106.917C136.986 106.917 163.423 119.998 164.737 104.643C166.218 87.2776 125.104 87.4512 125.104 87.4512L117.546 97.3907L122.912 118.254L129.18 120.949V120.958Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M116.887 115.641C115.407 119.23 117.111 123.348 120.708 124.828C124.296 126.308 128.414 124.605 129.895 121.008C131.375 117.419 129.671 113.301 126.074 111.821C122.485 110.341 118.368 112.044 116.887 115.641Z",
    fill: "#F0B99B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M125.732 120.817C125.732 120.817 127.683 116.104 122.863 114.979",
    stroke: "black",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M148.22 118.08C148.22 118.08 151.726 118.609 151.502 120.188C151.502 120.188 151.321 121.255 148.278 120.726C145.226 120.197 144.49 119.758 144.375 118.692C144.267 117.625 146.599 117.691 148.22 118.072V118.08Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M144.937 127.292C144.937 128.119 145.607 128.788 146.434 128.788C147.261 128.788 147.931 128.119 147.931 127.292C147.931 126.465 147.261 125.795 146.434 125.795C145.607 125.795 144.937 126.465 144.937 127.292Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M146.432 138.066C146.432 138.066 143.794 137.744 142.537 135.751",
    stroke: "black",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.568 89.5604C145.568 89.5604 154.433 80.1006 164.513 89.2793C171.756 95.878 167.597 110.828 157.277 111.945C146.957 113.061 140.656 90.0317 140.656 90.0317L145.56 89.5604H145.568Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.423 136.182L90.6811 150.636L114.711 162.461L119.73 153.266L101.423 136.182Z",
    fill: "#FDF9FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M90.121 147.245C84.4236 152.471 74.3437 163.089 64.3795 180.289C58.1115 191.113 53.4477 202.797 50.3055 214.911C46.3446 230.192 39.3736 255.421 41.2838 270.827C41.2838 270.827 67.6539 273.134 102.921 248.723L123.652 178.147C123.652 178.147 125.835 158.111 100.631 145.757C97.1414 144.045 92.9821 144.624 90.121 147.245Z",
    fill: "#48D6C6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M154.486 203.682L117.002 158.252L88.2423 188.12L125.478 217.128L132.283 222.428L132.358 222.329L143.248 230.565C145.481 232.153 150.699 233.393 153.436 233.55L202 220.915L198.866 199.308L154.469 203.682H154.486Z",
    fill: "#48D6C6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M117.833 211.166L91.9761 191.022",
    stroke: "#3395D4",
    strokeWidth: 0.77,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M198.87 199.316C198.87 199.316 225.728 190.857 232.848 205.948C236.742 214.201 238.594 219.733 239.471 223.049C240 225.058 238.504 227.026 236.42 227.026C235.27 227.026 234.212 226.398 233.658 225.397L230.003 218.765C230.003 218.765 218.129 229.11 205.593 216.574L201.475 217.268L198.87 199.316Z",
    fill: "#FFBB9B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4008 310.353L110.577 431.991",
    stroke: "#1F2421",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.374 310.353L45.001 431.991",
    stroke: "#1F2421",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115.056 319.399H37.5748C35.0585 319.399 33.0186 317.359 33.0186 314.843V309.592C33.0186 307.076 35.0585 305.036 37.5748 305.036H115.056C117.572 305.036 119.612 307.076 119.612 309.592V314.843C119.612 317.359 117.572 319.399 115.056 319.399Z",
    fill: "white",
    stroke: "#1F2421",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M283.315 232.525H199.161C196.689 232.525 194.687 230.524 194.687 228.052C194.687 225.579 196.689 223.578 199.161 223.578H283.315C285.788 223.578 287.789 225.579 287.789 228.052C287.789 230.524 285.788 232.525 283.315 232.525Z",
    fill: "#1F2421"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M326.605 159.782L283.936 228.052",
    stroke: "#050001",
    strokeWidth: 1.26,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M292.047 240.844V431.992",
    stroke: "#1F2421",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M171.243 240.844V431.992",
    stroke: "#1F2421",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M152.502 232.525H313.485C316.001 232.525 318.041 234.565 318.041 237.082V245.632C318.041 248.148 316.001 250.188 313.485 250.188H152.502C149.986 250.188 147.946 248.148 147.946 245.632V237.082C147.946 234.565 149.986 232.525 152.502 232.525Z",
    fill: "white",
    stroke: "#1F2421",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.10352e-05 434.44C6.10352e-05 442.122 72.2634 448.341 161.396 448.341C250.528 448.341 322.792 442.114 322.792 434.44C322.792 426.767 250.528 420.54 161.396 420.54C72.2634 420.54 6.10352e-05 426.767 6.10352e-05 434.44Z",
    fill: "#BBB5BD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M272.804 207.363L274.565 213.937L279.551 232.46H292.253L297.247 213.945L299.017 207.363H272.804Z",
    fill: "#3F0099"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M270.72 207.405H301.093C301.093 199.012 294.296 192.223 285.903 192.223C277.509 192.223 270.72 199.012 270.72 207.405Z",
    fill: "#3E49DC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M278.069 218.113L280.938 228.797H290.456L293.143 218.799L293.739 216.583C291.539 216.087 288.81 216.013 285.701 216.997C284.56 217.361 283.477 217.617 282.443 217.791C280.839 218.063 279.367 218.146 278.069 218.113Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqLeft);
export default __webpack_public_path__ + "static/media/faqLeft.c4fd65b65737de0cfad8271fd1ff6f5b.svg";
export { ForwardRef as ReactComponent };